var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts"},_vm._l((_vm.datas),function(data){return _c('div',{key:data.id},[_c('Panel',{attrs:{"data":data,"mode":_vm.mode}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }